import { alertConstants } from '../_constants';

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: 'alert-success',
        message: action.message,
        width: action.width,
        height: action.height
      };
    case alertConstants.ERROR:
      return {
        type: 'alert-danger',
        message: action.message,
        width: action.width,
        height: action.height
      };
    case alertConstants.CLEAR:
      return {};
    default:
      return state
  }
}